// German for the client page (the standing brief). Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  'That client does not exist (anymore).': 'Dieser Kunde existiert nicht (mehr).',
  'This task carries no route — open it on the engagement it belongs to.': 'Diese Aufgabe trägt keine Route — öffnen Sie sie im Auftrag, zu dem sie gehört.',
  '← Clients': '← Kunden',
  'The full timeline': 'Die vollständige Zeitachse',
  'The library': 'Die Bibliothek',
  'The client record': 'Der Kundendatensatz',
  '← Back to the brief': '← Zurück zum Briefing',
  'active': 'aktiv',
  'dormant': 'ruhend',
  'archived': 'archiviert',
  'nothing on the client record yet': 'noch nichts im Kundendatensatz',
  'Record': 'Datensatz',
  'New engagement': 'Neuer Auftrag',
  'Legal name': 'Rechtlicher Name',
  'Short name': 'Kurzname',
  'Sector': 'Branche',
  'Address': 'Adresse',
  'First contact': 'Erstkontakt',
  'no dated evidence': 'keine datierten Belege',
  'On the record since': 'Erfasst seit',
  'Sponsor': 'Sponsor',
  'nobody named': 'niemand benannt',
  'Open the record →': 'Datensatz öffnen →',
  '{code} created — open it from the switcher or the Lifecycle page': '{code} erstellt — öffnen Sie ihn über den Umschalter oder die Lifecycle-Seite',
}, 'ClientPage');
